import httpRequest from "~/composables/requset";
import type {ResponseData} from '~/utils/types';
import {useUserStore} from "~/stores/user";

// 收藏清單:JWT 帶使用者,無 body;回 {space_ids:[...]}(新到舊)
export function getFavorites(): Promise<ResponseData> {
    return httpRequest('GET', '/api/favorites')
}

// 加入收藏(後端 idempotent);POST body {space_id}
export function addFavorite(spaceId: number): Promise<ResponseData> {
    return httpRequest('POST', '/api/favorites', {space_id: spaceId})
}

// 移除收藏。後端以 JSON body 解析 space_id(ShouldBindJSON),但共用的 httpRequest
// 會把 DELETE 的 data 塞進 query string(見 composables/requset.ts),故此處直接用 $fetch
// 帶 body,並沿用同樣的 baseURL / Bearer token / envelope 判斷。
export async function removeFavorite(spaceId: number): Promise<ResponseData> {
    const config = useRuntimeConfig()
    const userStore = useUserStore()
    const res: {error_code: string; data: ResponseData} = await $fetch(
        config.public.baseURL + '/api/favorites',
        {
            method: 'DELETE',
            credentials: 'include',
            body: {space_id: spaceId},
            headers: userStore.getToken ? {Authorization: 'Bearer ' + userStore.getToken} : {},
        }
    )
    if (res?.error_code === '00000') {
        return res.data
    }
    return Promise.reject(res)
}
